import React from "react";
import { bool, object, string, func, number, oneOfType } from "prop-types";
import { Row, Col, Dropdown } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import { trackTalentMobilityJobClicked } from "utils/trackingFunctions";

const OtherPotentialJobs = (props) => {
  const {
    fromCandidateProfile,
    jobs,
    selectedPotentialJob,
    setSelectedPotentialJob,
    setSelectedJobToCopyCandidate,
    setShowCopyCandidateConfirmationModal,
    candidateFirstName,
    moveEmailCandidatesPermission,
    companyAccountId,
    pipelineStageName,
  } = props;
  const showCopyCandidate =
    fromCandidateProfile && moveEmailCandidatesPermission;

  const otherPotentialJobs =
    jobs &&
    jobs.entrySeq().map(([id, job]) => {
      const onDropdownSelection = (event) => {
        if (event === "copyCandidate") {
          const updatedJob = job.setIn(["jobDetailId"], id);

          setSelectedJobToCopyCandidate(updatedJob);
          setShowCopyCandidateConfirmationModal(true);
        }

        return true;
      };

      const handlePotentialJobClick = () => {
        trackTalentMobilityJobClicked(id, pipelineStageName, companyAccountId);
        setSelectedPotentialJob(id);
      };

      return (
        <Row
          key={id}
          className={`score-report-job-row ${
            selectedPotentialJob === id && "active"
          } my-1 mx-0`}
          style={{ padding: "12px 16px" }}
          onClick={handlePotentialJobClick}
        >
          <Col lg={11} className="d-flex align-items-center px-0">
            <strong>{job.get("jobTitle")}</strong>{" "}
            {fromCandidateProfile && (
              <>
                <span className="mx-1">|</span>
                <div>{job.get("jobCode")}</div>
              </>
            )}
          </Col>
          {showCopyCandidate && (
            <Col lg={1} className="d-flex justify-content-end pr-0">
              <Dropdown id="actions" onSelect={onDropdownSelection}>
                <div className="no-caret">
                  <Dropdown.Toggle
                    size="sm"
                    variant="outline-secondary"
                    className="dropdown-toggle-no-background p-0"
                  >
                    <FontAwesome name="ellipsis-h" fixedWidth />
                  </Dropdown.Toggle>
                </div>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="copyCandidate" key="copyCandidate">
                    Copy {candidateFirstName} to this Job
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          )}
        </Row>
      );
    });

  return (
    <div className="score-report-job-container" style={{ marginTop: "9px" }}>
      {otherPotentialJobs}
    </div>
  );
};

OtherPotentialJobs.propTypes = {
  fromCandidateProfile: bool,
  jobs: object,
  selectedPotentialJob: string,
  setSelectedPotentialJob: func,
  setSelectedJobToCopyCandidate: func,
  setShowCopyCandidateConfirmationModal: func,
  candidateFirstName: string,
  moveEmailCandidatesPermission: bool,
  companyAccountId: number,
  pipelineStageName: oneOfType([string, bool]),
};

export default OtherPotentialJobs;
